import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ButtonStyled } from "./ButtonLegacy.styles.js";
import { LeftIcon, RightIcon } from "./Button.styles.js";
import { Spinner } from "./Spinner.js";
const ButtonLegacy = forwardRef(({
  children,
  className = "",
  rightIcon,
  type = "button",
  "aria-label": ariaLabel,
  isFullWidth = false,
  icon,
  variant = "secondary",
  isSmall = false,
  isDisabled = false,
  isPressed = false,
  isLoading = false,
  ...props
}, ref) => {
  const classNames = getClassName({
    className,
    variant,
    isSmall,
    icon,
    isDisabled
  });
  return /* @__PURE__ */ jsx(ButtonStyled, {
    "aria-label": ariaLabel || props.title,
    className: classNames,
    disabled: isDisabled || isLoading,
    type,
    $variant: variant,
    $isPressed: isPressed,
    $isSmall: isSmall,
    $isFullWidth: isFullWidth,
    as: props.href ? "a" : "button",
    ref,
    ...props,
    children: isLoading ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(LeftIcon, {
        $lastChild: !children,
        children: /* @__PURE__ */ jsx(Spinner, {})
      }), children]
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [icon && /* @__PURE__ */ jsx(LeftIcon, {
        $lastChild: !children,
        children: icon
      }), children, rightIcon && /* @__PURE__ */ jsx(RightIcon, {
        children: rightIcon
      })]
    })
  });
});
function getClassName({
  variant,
  isSmall,
  icon,
  isDisabled,
  className = ""
}) {
  return [className, "action-btn", variant === "secondary" || variant === "clean" ? "cancel gray" : "cta-main blue", isSmall ? "button-small" : "", icon ? "button-icon" : "", isDisabled ? "disabled" : ""].join(" ");
}
export {
  ButtonLegacy
};
//# sourceMappingURL=ButtonLegacy.js.map
